import { HttpParams } from "@angular/common/http";
import { forwardRef, Inject, Injectable } from "@angular/core";
import { firstValueFrom } from "rxjs";
import { PROBLEMS } from "../common/endpoints";
import { PagedList, Problem } from "../model";
import { HttpService } from "./http.service";

@Injectable()
export class ProblemService {

    constructor(
        @Inject(forwardRef(() => HttpService)) private httpService: HttpService
    ) { }

    getPagedList(page: number, size: number, sort: string[], advancedSearchBody?: any): Promise<PagedList<Problem>> {
        let params = this.getParams(advancedSearchBody);
        params = params.set('page', page + '');
        params = params.set('size', size + '');
        if (sort && sort[0]) {
            params = params.set('sort', sort.join(','));
        }
        return firstValueFrom(this.httpService.get<PagedList<Problem>>(PROBLEMS, params));
    }

    private getParams(advancedSearchBody: any): HttpParams {
        let params = new HttpParams();
        if (advancedSearchBody) {
            if (advancedSearchBody.key) {
                params = params.set('searchText', "*" + advancedSearchBody.key + "*");
            }
        }
        return params;
    }
}